import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Search } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-enquiry-report-form',
  templateUrl: './enquiry-report-form.component.html',
  styleUrls: ['./enquiry-report-form.component.css']
})
export class EnquiryReportFormComponent implements OnInit {

  title="Preliminary Enquiry";
  Comp_id: any;
  Court_Proc_Id: any;
  ReltaedDocDetails: any = {};
  ComplaintDetails: any = {};
  r: any = {};
  p: any = {};
  fileToUpload: File = null;
  formSubmitted: boolean;
  formInvalid: boolean;
  data: any;
  // p:any={};

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.formSubmitted = false;
  }

  ngOnInit() {
    this.route.params.subscribe(params =>
      this.Comp_id= params['Comp_id'],
      
       
    );
    if (this.Comp_id != null)
      this.GetCompForTheIdCp(this.Comp_id);
    
  }

  GetCompForTheIdCp(Comp_id) {
    debugger;
     
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetCompForTheIdCp(Comp_id)
    
      .subscribe(
        (data: any) => {
           this.ComplaintDetails = data;
          // this.ReltaedDocDetails=data.RelatedDocumentModels;       
          this.p = data.PrimilmanryEnqModels;
        
          this.ReltaedDocDetails=data.PrimilmanryEnqModels.RelatedDocumentModels;  

          if (this.p.PrEnq_Date!= null)
          this.p.PrEnq_Date = ((this.p.PrEnq_Date).split('T'))[0];

          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
       
  }

  

  //Update

  UpdateEnqDetails(PrEnq_Id,Enq: NgForm) {
    debugger;
    
    Enq.value.Comp_id = this.Comp_id;
    // Enq.value.Court_Proc_FilePath = this.getFeasibilitySignFUrl();
    Enq.value.PrEnq_Upload = this.getPr_EnqUploadPathUrl();
    this.data = this.userService.UpdateEnqDetails(Enq.value, PrEnq_Id);
    this.data.subscribe(
      (response) => {
        Enq.reset();
        Enq.resetForm();
        Enq.form.markAsPristine();
        Enq.form.markAsUntouched();

        swal('Success!', ' updated Successfully .', 'success');
        document.getElementById('loader-spinner').style.display = "none";
        //this.router.navigate(['/home/court-proceedings']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });

  }
 


//adding Documents details

  onSubmit(PrEnq_Id: any, form: NgForm) {
    // this.CourtProc.Court_Proc_Id=this.Court_Proc_Id;
    debugger
    if (!form.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      form.value.Rdocument_FilePath = this.getFeasibilityDocBriefFUrl();
      this.userService.PostReleatedDoc(PrEnq_Id, form.value)
        .subscribe(
          (data) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.GetCompForTheIdCp(this.Comp_id)
            form.reset();
            form.resetForm();
            this.formSubmitted = false;
            swal('', 'Saved Successfully!', 'success');
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.handleError(error);
          });
    } else
      document.getElementById('loader-spinner').style.display = "none";
    this.formSubmitted = true;
  }

  
  //upload file paths
  imageUpload1(file: FileList) {
    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        //  this.IS_UploadPath = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage1(data);
      x.subscribe(
        (response) => {

        }, (error) => {
          let i: any = document.getElementById('Rdocument_FilePath');
          i.value = "";
          if (error.status == 400) {
            //this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('Rdocument_FilePath');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getFeasibilityDocBriefFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('Rdocument_FilePath');
      console.log('CourtDoc file');
      console.log(imagename.files[0].name);
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  

  Cancel(){
    this.p.PrEnq_Note = '';
    this.p.PrEnq_Date = '';
    this.p.PrEnq_Status = '';
    this.p.PrEnq_ForwordT = '';
    // this.CourtProc.Fir_Date = '';
  }

  


  RelatedDocDetailsdelete(Rdocument_Id){
    debugger;
    swal({
         title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
        this.data = this.userService.RelatedDocDetailsdelete(Rdocument_Id);
        this.data.subscribe(
         (response: any) => {
          this.GetCompForTheIdCp(this.Comp_id);
         },(error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        }       
      ); 
    } 
    })
    }

//Priliminary upload
    PrEnqUpload(file: FileList) {
      let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
      //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdef|.pdf|.PDF)$/;
      let s: any = file.item(0).size / 1024;
      let size: any = parseFloat(s).toFixed(2);
      let uploadedFilename = file.item(0).name;
      if (uploadedFilename.match(regex) && (size <= 2048)) {
        this.fileToUpload = file.item(0);
        var reader = new FileReader();
        reader.onload = (event: any) => {
          //this.fingerprintimageUrl = event.target.result;
        }
        reader.readAsDataURL(this.fileToUpload);
        const data = new FormData();
        data.append("UploadedImage", file.item(0));
        let x = this.userService.uploadImage1(data);
        x.subscribe(
          (response) => {
            //console.log(response);
          }, (error) => {
            let i:any=document.getElementById('PrEnq_Upload');
            i.value="";
            if (error.status == 400) {
             // this.fingerprintimageUrl = "assets/images/image-default.png";
              swal('Warning!', error.error.Message, 'warning');
            }
          });
      }
      else {
        let i: any = document.getElementById('PrEnq_Upload');
        i.value = "";
        if (!uploadedFilename.match(regex))
          swal('Warning!', "Please upload image file with extension jpg, jpeg, pdf or png", 'warning');
        else if (size > 2048)
          swal('Warning!', "Please upload image file less than 2mb", 'warning');
      }
    }



    getPr_EnqUploadPathUrl() {
      let imagename = null;
      try {
        imagename = document.getElementById('PrEnq_Upload');
        console.log(imagename.files[0].name);
        return imagename.files[0].name;
      }
      catch (e) {
        return null;
      }
    }
  

}


// WEBPACK FOOTER //
// ./src/app/enquiry-reports/enquiry-report/enquiry-report-form/enquiry-report-form.component.ts